<template>
    <div class="pg-product-list">
        <header>
            <div class="toptitle">
                <!-- <h1>{{searchName}}</h1>
                <div class="header-right">
                    <span>
                        当前分类下共有<em>{{counts}}</em>个产品
                    </span>
                </div> -->
                <img :src="searchName.logo" alt="" class="compony-logo" v-if="searchName.logo != ''" />
                <img src="../../assets/images/compony-default.png" alt="" class="compony-logo"
                    v-if="searchName.logo == ''" />
                <div class="compony-info">
                    <p class="top">
                        <span class="name">{{ searchName.companyName }}</span>
                        <span class="f-right product">{{ counts }}个产品</span>
                    </p>
                    <p class="slogan" :data-text="searchName.description">简介：{{ searchName.description ?
                        searchName.description.length > 25 ? searchName.description.slice(0, textLength) :
                        searchName.description : '' }} <span
                            v-show="searchName.description ? searchName.description.length > 25 : false"
                            :style="{ color: '#3f89f7' }" @click="textCut(searchName.description)"> {{ textLength <= 25
                                ? '展开' : '收起' }}</span>
                    </p>
                </div>
            </div>
            <!-- <div class="tabs" v-show="tabsName.length>0"> -->
            <!-- <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <a href="javasciprt: void(0);" :class="{active:tabIdx==0}" @click="tabHandle(0)">全部</a>
                    </div>
                    <div class="swiper-slide" v-for="(tabItem,index) in tabsName" :key="tabItem.id">
                        <a href="javasciprt: void(0);" :class="{active:tabIdx==index+1}" @click="tabHandle(index+1, tabItem)">{{tabItem.name}}</a>
                    </div>
                </div>
            </div> -->
            <!-- </div> -->
        </header>

        <div class="list fixtab" id="product-list">
            <ul>
                <li v-for="product in productList" :key="product.pId">
                    <router-link
                        :to="{ path: '/prodetail', query: { id: product.pId, munufacturer_id: product.munufacturer_id } }">
                        <div class="img-wrapper">
                            <img :src="imgHost + product.pImg" alt="产品图" v-show="product.pImg">
                        </div>
                        <div class="item-right">
                            <h3>{{ product.pName }}</h3>
                            <p><span>商标:{{ product.trademark }}</span></p>
                            <p><span>牌号：{{ product.grade }}</span></p>
                            <p><span>CAS号：{{ product.cas }}</span></p>
                        </div>
                    </router-link>
                </li>
                <li class="nomore">{{ loadtips }}</li>
            </ul>
        </div>
        <div class="ctrls">
            <a href="javascript: void(0)" @click="navigateHome"><span><img src="../../assets/images/home.png"
                        alt="返回首页"></span></a>
            <transition name="fade">
                <span v-show="backTopShow"><img src="../../assets/images/top.png" alt="回到顶部" @click="scroolTop"></span>
            </transition>
        </div>
    </div>
</template>
<script>
    //import Swiper from 'swiper'
    import config from '../../common/config'
    import { Loading, Message } from 'element-ui';
    import axios from 'axios';
    import Jroll from 'jroll'

    //var mySwiper;
    export default {
        data() {
            return {
                imgHost: config.PHPHOST,
                listRoll: '',
                backTopShow: false,
                productList: [],
                tabsName: [],
                tabIdx: 0,
                counts: "" || 0,
                loading: false,
                loadtips: "加载中...",
                totalPage: 0,
                searchName: "",
                queryStr: {
                    partId: '',
                    cate3: '',
                    pageSize: 10,
                    page: 0
                },
                textLength: 25,

            }
        },
        created() {
            this.queryStr.partId = this.$route.query.cid;
        },
        mounted() {
            _hmt.push(['_trackPageview', `/#/companypro?cid=${this.queryStr.partId}`]);
            window.addEventListener('scroll', this.handleScroll);
            this.getData();
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            // 截取字符串
            textCut(data) {
                if (this.textLength <= 25) {
                    this.textLength = data.length;
                } else {
                    this.textLength = 25;
                }
            },

            handleScroll() {
                if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                    this.backTopShow = true;
                } else {
                    this.backTopShow = false;
                }
                if (this.loading) return;
                if (document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 650 || document.body.scrollHeight - document.documentElement.scrollTop - window.innerHeight < 650) {
                    this.loadmore()
                }
            },
            scroolTop() {
                window.scrollTo(0, 0);
            },
            getData() {
                let str = this.queryStr;
                axios.get(config.PHPHOST + 'api/web/index.php?r=company/company-product-list', { params: str }).then(function (res) {
                    if (res.data.flag == 0) {
                        if (res.data.data.className && res.data.data.className.length > 0) {
                            this.tabsName = res.data.data.className;
                        }
                        this.productList.push.apply(this.productList, res.data.data.product);
                        this.counts = res.data.data.counts;
                        if (this.totalPage <= 1) {
                            this.loadtips = '没有更多数据了'
                        }
                        this.totalPage = Math.ceil(res.data.data.counts / 10)
                        this.loading = false;
                        this.searchName = res.data.data.searchName;

                        WeChatShare({
                            callback: () => {
                                var title = this.searchName.companyName + '-优料库',
                                    desc = this.searchName.description || '在线支持原料性能搜索,通过覆盖全球供应商的产品数据库资源,为用户提供数据查询、资料下载、在线培训和试样申请等专业信息服务。',
                                    imgUrl = config.PHPHOST + 'frontend/web/images/logo-new.jpg',
                                    link = window.location.origin + '?path=companypro&cid=' + this.queryStr.partId;

                                wx.onMenuShareAppMessage({
                                    title: title,
                                    desc: desc,
                                    link: link,
                                    imgUrl: imgUrl
                                });
                                wx.onMenuShareTimeline({
                                    title: title + " - " + desc,
                                    link: link,
                                    imgUrl: imgUrl
                                });
                            },
                            data: 'url=' + encodeURIComponent(window.location.href),
                            url: config.MAPI
                        });
                    } else {
                        this.loadtips = '没有更多数据了';
                        Message({
                            message: res.data.msg,
                            showClose: false,
                            customClass: 'search-msg-style',
                            duration: 2000
                        });
                    }
                }.bind(this))
                    .catch(function (err) {
                        Message({
                            message: '网络请求出错',
                            showClose: false,
                            customClass: 'search-msg-style',
                            duration: 2000
                        });
                    }.bind(this))
            },
            loadmore() {
                this.loading = true;
                if (this.totalPage > this.queryStr.page + 1) {
                    this.queryStr.page++
                    this.getData()
                } else {
                    this.loadtips = '没有更多数据了'
                    return false;
                }
            },
            tabHandle(tabItemIndex, item) {
                if (this.tabIndex === tabItemIndex) return;
                this.tabIdx = tabItemIndex;
                this.queryStr.page = 0;
                this.queryStr.cate3 = item ? item.id : '';
                this.loadtips = '加载中...';
                this.productList = [];
                this.loading = false;
                this.getData();
            },
            navigateHome() {
                window.location.href = window.location.origin;
            }
        }
    }
</script>
<style lang="less" scoped>

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }

    .pg-product-list {
        header {
            position: static;
            background: #fff;
            width: 100%;

            .toptitle {
                display: flex;
                height: auto;
                padding: 1rem;
                line-height: 4rem;
                border-bottom: 1px solid #f1f1f1;

                .compony-logo {
                    width: 6.6rem;
                    height: 6.6rem;
                    margin-right: 1rem;
                    border: 1px solid #e4e4e4;
                }

                .compony-info {
                    line-height: 1.4rem;
                    flex: 1 1;
                }

                .f-right {
                    float: right;
                }

                .name {
                    width: 60%;
                    float: left;
                    font-size: 1.4rem;
                    font-weight: 600;

                }

                .product {
                    font-size: 1.2rem;
                    color: #0994ff;
                }

                .slogan {
                    float: left;
                    width: 100%;
                    margin-top: 1.5rem;
                    font-size: 1.2rem;
                    color: #999;
                }

                .line-clamp-1 {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                }
            }

            h1 {
                font-size: 1.6rem;
                padding-left: 1rem;
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .header-right {
                flex: 1;
                text-align: right;
                padding-right: 1rem;
                font-size: 1.4rem;
                color: #666;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;

                em {
                    color: #0994ff;
                    font-weight: 600;
                }
            }

        }

        .tabs {
            height: 4rem;
            line-height: 4rem;
            border-bottom: .1rem solid #ddd;
            ;

            .swiper-slide {
                text-align: center;
            }

            a {
                color: #333;
                display: block;
                width: 80%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

            }

            a.active {
                color: #0994ff;
                border-bottom: .2rem solid #0994ff;
            }
        }

        .fixtab {
            padding-top: 0px !important;
        }

        .list {
            padding-top: 9rem;

            ul {
                li {
                    a {
                        border-bottom: .1rem solid #e1e1e1;
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        display: flex;
                    }

                    .img-wrapper {
                        flex: none;
                        width: 8rem;
                        height: 8rem;
                        border: .1rem solid #ddd;
                        border-radius: .4rem;
                        margin: 1rem;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                    }

                    .item-right {
                        flex: 1;
                        padding-right: 3rem;
                        position: relative;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        &::after {
                            content: '';
                            position: absolute;
                            width: 2rem;
                            height: 100%;
                            right: 0;
                            top: 0;
                            background: url(../../assets/images/arrow-r.png) center no-repeat;
                            background-size: .7rem;
                        }

                        h3 {
                            width: 100%;
                            font-size: 1.5rem;
                            margin-top: 1rem;
                            line-height: 2rem;
                            font-weight: 400;
                            overflow: hidden;
                            text-overflow: ellipsis;

                        }

                        p {
                            line-height: 2rem;
                            color: #999;
                            font-size: 1.3rem;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }

        .ctrls {
            position: fixed;
            width: 3rem;
            height: 7rem;
            bottom: 6rem;
            right: 1rem;

            span {
                display: block;
                width: 3rem;
                height: 3rem;
                margin-bottom: 1rem;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/company/company-product.vue